import getWithToken from './base/get-with-token'

const getCustomersList = getWithToken('/customer')

export default getCustomersList